import axiosInstance from "../../apis/axios/axios";

const saveNewUser = async (request) => {
    try {
        const response = await axiosInstance.post(
            `/User/addUser/${request.userId}/${request.contact.companyId}`,
            request
        );
        console.log("saveNewUser--->", response?.data);
        return response?.data;
    } catch (error) {
        console.error(
            "Error fetching saveNewUser:",
            error
        );
    }
};

const saveEditUser = async (userId, request) => {
    try {
        debugger
        const response = await axiosInstance.post(
            `/User/updateUser/${userId}/${request.contact.companyId}`,
            request
        );
        console.log("saveEditUser--->", response?.data);
        return response?.data;
    } catch (error) {
        console.error(
            "Error fetching saveEditUser:",
            error
        );
    }
};

const getSalesUsers = async () => {
    try {
        const response = await axiosInstance.get(`/User/getSalesUsers/`);
        console.log("getSalesUsers--->", response?.data);
        return response?.data;
    } catch (error) {
        console.error(
            "Error fetching getSalesUsers:",
            error
        );
    }
};

const getAllUsers = async (id) => {
    try {
        const response = await axiosInstance.get(`/User/getUsers/${id}`);
        console.log("getAllUsers--->", response?.data);
        return response?.data;
    } catch (error) {
        console.error("Error fetching getAllUsers:", error);
    }
};

const changePassword = async (userId, request) => {
    try {
        const response = await axiosInstance.post(`/User/changePassword/${userId}`, {
            id: userId,
            //oldPassword: "",
            newPassword: request.newPassword,
            confirmNewPassword: request.confirmNewPassword,
        });
        return response?.data;
    }
    catch (error) {
        console.error("Error fetching changePassword:", error);
    }
}
const customerDropdown = async () => {
    try {
        const response = await axiosInstance.get(`/Customer/getAllCustomers/0`);
        console.log("getCustomers--->", response?.data);
        return response?.data;
    } catch (error) {
        console.error("Error fetching customerDropdown:", error);
    }
}
const supplierDropdown = async () => {
    try {
        const response = await axiosInstance.get(`/Supplier/getAllSuppliers/0`);
        console.log("getSuppliers--->", response?.data);
        return response?.data;
    } catch (error) {
        console.error("Error fetching supplierDropdown:", error);
    }
}

const directLoginUserToken = async (userName) => {
    try {
        debugger;
        const response = await axiosInstance.get(`User/directLoginToken?userName=${userName}`)
        return response;
    } catch (error) {
        console.log("Error fetching directLoginUserToken:", error)
    }
}

const directLogin = async (body) => {

    try {
        debugger;
        const response = await axiosInstance.post('/User/directLogin', body); // replace with your endpoint
        //.log('login--->', response?.data);
        return response;
    } catch (error) {
        console.error('Error fetching directLogin:', error);
    }
}
const resendCredentials = async (userId, companyId, body) => {
    try {
        debugger;
        const response = await axiosInstance.post(`/User/emailLoginCredentials/${userId}/${companyId}`, body)
        return response;
    } catch (error) {
        console.log("Error in fetching resendCredentials--->", error)
    }
}
export const UsersService = {
    saveNewUser,
    saveEditUser,
    getSalesUsers,
    getAllUsers,
    changePassword,
    customerDropdown,
    supplierDropdown,
    directLoginUserToken,
    directLogin,
    resendCredentials,
};